module.exports = __webpack_public_path__ + "static/media/icon-drive.4ff30161.svg";